import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20amber%20and%20coral%20gradients%2C%20Japanese%20and%20Korean%20cultural%20elements%20subtly%20blended%2C%20soft%20bokeh%20lighting%20effects%2C%20elegant%20minimalist%20design%2C%20streaming%20media%20aesthetic%20with%20film%20reel%20motifs%2C%20warm%20atmospheric%20glow&width=1600&height=900&seq=hero-bg-home-01&orientation=landscape"
        alt="日韩在线 - 日韩国产在线与日韩激情在线高清视频平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 mb-4 max-w-3xl leading-tight">
          日韩国产在线与<strong>日韩激情在线</strong>高清一区二区
        </h1>
        <p className="text-sm md:text-lg text-background-200 max-w-2xl mb-8 leading-relaxed">
          日韩在线品牌专区汇聚日韩剧、综艺、动漫等最新高清视频，<strong>日韩精品在线</strong>久久免费观看全集，不缓冲畅享极致观影体验
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category"
            className="bg-primary-500 text-background-50 dark:text-foreground-950 px-8 py-3 rounded-full text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>立即观看
          </Link>
          <Link
            to="/about"
            className="border border-background-50/40 text-background-50 px-8 py-3 rounded-full text-base font-medium whitespace-nowrap hover:bg-background-50/10 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}